import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { useState } from 'react';
import { useTheme } from 'emotion-theming';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Tab, Tabs as MuiTabs } from '@material-ui/core';

var TabsContainer = _styled("div", {
  target: "e1ahae510",
  label: "TabsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "8atqhb",
  styles: "width:100%;"
} : {
  name: "8atqhb",
  styles: "width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var getMuiThemeWithOverrides = function getMuiThemeWithOverrides(theme) {
  return createMuiTheme({
    typography: {
      fontFamily: "'Poppins SemiBold', sans-serif"
    },
    overrides: {
      MuiTabs: {
        root: {
          background: theme.colors.tertiary,
          color: theme.colors.white
        },
        indicator: {
          display: 'none'
        }
      },
      MuiTab: {
        root: _defineProperty({
          background: theme.colors.tertiary,
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px',
          height: '34px',
          lineHeight: '27px',
          maxWidth: 'none',
          padding: '0 1rem',
          transition: '.2s ease all',
          '&$textColorInherit': {
            opacity: 1
          },
          '&$selected': {
            backgroundColor: theme.colors.white,
            color: theme.colors.primary
          }
        }, theme.MQ.S, {
          fontSize: '18px',
          padding: '0 2rem'
        })
      },
      MuiTabScrollButton: {
        root: {
          flexShrink: 'inherit'
        }
      }
    }
  });
};

/**
 * Tabs Component, displays number of tabs and elements within the corresponding tab body
 *
 * @param {Array} props.tabData :: list of tab required data - label for the tab and panel component for tab body
 */
export function Tabs(_ref) {
  var tabData = _ref.tabData;
  var theme = useTheme();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var handleTabChange = function handleTabChange(event, newTab) {
    setCurrentTab(newTab);
  };

  return /*#__PURE__*/React.createElement(TabsContainer, null, /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: getMuiThemeWithOverrides(theme)
  }, /*#__PURE__*/React.createElement(MuiTabs, {
    onChange: handleTabChange,
    value: currentTab,
    variant: "scrollable"
  }, tabData.filter(function (isDefined) {
    return !!isDefined;
  }).map(function (tab, i) {
    return tab && /*#__PURE__*/React.createElement(Tab, {
      key: "tab-".concat(i),
      label: tab.label,
      index: i
    });
  }))), tabData.filter(function (isDefined) {
    return !!isDefined;
  }).map(function (tab, i) {
    return tab && /*#__PURE__*/React.createElement("div", {
      hidden: currentTab !== i,
      key: "panel-".concat(i),
      role: "tabpanel"
    }, /*#__PURE__*/React.createElement(tab.panel, null));
  }));
}